import type { Contact, ContactLabels, ContactType } from "../model/Contact";
import API, { responseOf } from "./base";

export const create = (contact: Contact): Promise<Contact> =>
  responseOf(API.post("/contact-info/create", contact));

export const updateById = (
  contact_id: string,
  new_contact: Contact,
): Promise<Contact> =>
  responseOf(API.post(`/contact-info/update/${contact_id}`, new_contact));

export const findById = (id: string): Promise<Contact> =>
  responseOf(API.get(`/contact-info/${id}`));

export const deleteById = async (id: string): Promise<void> => {
  await API.delete(`/contact-info/${id}`);
};

export const getAllOrgContacts = (org_id: string): Promise<Contact[]> =>
  responseOf(API.get(`/contact-info/organization/${org_id}/all`));

export const findOneByDetailsGlobal = (
  org_id: string,
  label: ContactLabels,
  type: ContactType,
  user_id?: string,
): Promise<Contact> =>
  responseOf(
    API.get(
      `/contact-info/organization/${org_id}${user_id ? `/user/${user_id}` : ""}/type/${type}/label/${label}`,
    ),
  );

export const getGlobalOrgContacts = (org_id: string): Promise<Contact[]> =>
  responseOf(API.get(`/contact-info/organization/${org_id}`));

export const getOrgUserContacts = (
  org_id: string,
  user_id: string,
): Promise<Array<Contact>> =>
  responseOf(API.get(`/contact-info/organization/${org_id}/user/${user_id}`));
